import React from 'react';
import { Card, Icon } from "semantic-ui-react";
import moment from "moment";
import { formatCurrency, sumKeyValueOfArray } from "../../utils/commonutils";
import { adpLink } from "../../constants"
import { showFinancialNotesTable, showTedCollectionsTable } from "./functions";
import PayDetailDateCell from './PayDetailDateCell';

const GreaterOf = ({ providerData, startDate, earnings, details, currentPeriod }) => {
    const { numberOfWorkedDays, patientVisits, patientVisitsPerDay, contractType, dentistWorkTimeType, prodAdjWo, percentageOfBillable, doctorPayVariables, sortName, financialNoteList, financialNotes } = providerData;
    const adjWoProcDateStart = doctorPayVariables?.GreaterofAdjWOProcdateStart;
    const annualizedPay = earnings * (currentPeriod != null ? 24 : 12);
    const dailyRatePay = (earnings / numberOfWorkedDays)
    const { payChecks, payDetailsList, hygData, isProviderOnTierBonus, tierBonusPayRecords } = details;
    const payDayValue = currentPeriod ? currentPeriod.paidOn : moment(startDate).add(1, 'months').format('MMMM YYYY');
    const workPeriodValue = currentPeriod ? currentPeriod.displayRange : moment(startDate).format('MMMM YYYY');
    const tierType = tierBonusPayRecords.flat().length > 0 ? (tierBonusPayRecords.flat())[0].tierType : 0;

    const calculateBCareHygTotal = (payDetailsListData) => {
        return payDetailsListData.reduce((total, iRow) => {
            return total + (hygData[iRow.date] ? hygData[iRow.date].billableCare : 0);
        }, 0);
    };

    const bCareHygTotal = calculateBCareHygTotal(details.payDetailsList);

    const showTableRow = (iRow) => {
        const billableNotes = iRow.billableNotes
        return (<tr>
            <td><PayDetailDateCell row={iRow} /></td>
            <td>{iRow.practice}</td>
            <td>{formatCurrency(iRow.care)}</td>
            <td>{formatCurrency(iRow.adjustmentPrice)}</td>
            <td>{formatCurrency(iRow.writeOffPrice * -1)}</td>
            <td>{formatCurrency(iRow.billableCare)} <b>{billableNotes ? ' ** ' : ''}</b></td>
            {Object.keys(hygData).length > 0 && <td>
                {formatCurrency(hygData[iRow.date] ? hygData[iRow.date].billableCare : 0)}
            </td>}
            <td>{formatCurrency(iRow.financialNotes)}</td>
            <td>{formatCurrency(iRow.totalPay)}</td>
        </tr>
        )
    }

    const showPayDetailsTableRows = (payDetailsListData) => {
        if (payDetailsListData && payDetailsListData.length > 0) {
            return (payDetailsListData.map(pRow => (showTableRow(pRow))))
        }
    }
    const showTableTotals = (payDetailsListData) => {
        return (<tr>
            <td><b>Total</b></td>
            <td></td>
            <td><b>{formatCurrency(sumKeyValueOfArray(payDetailsListData, 'care'))}</b></td>
            <td><b>{formatCurrency(sumKeyValueOfArray(payDetailsListData, 'adjustmentPrice'))}</b></td>
            <td><b>{formatCurrency(sumKeyValueOfArray(payDetailsListData, 'writeOffPrice') * -1)}</b></td>
            <td><b>{formatCurrency(sumKeyValueOfArray(payDetailsListData, 'billableCare'))}</b></td>
            {Object.keys(hygData).length > 0 && <td><b>
                {formatCurrency(bCareHygTotal)}
            </b></td>}
            <td><b>{formatCurrency(sumKeyValueOfArray(payDetailsListData, 'financialNotes'))}</b></td>
            <td><b>{formatCurrency(sumKeyValueOfArray(payDetailsListData, 'totalPay'))}</b></td>
        </tr>)
    }


    return (
        <div>
            <div className="row">
                {/* First Column */}
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="ui card reports-card">
                        <div className="content">
                            <h5>{sortName}</h5>
                            <ul className="data-list">
                                <li>
                                    <p>{currentPeriod != null ? 'Pay Day' : 'Pay Month'}</p>
                                    <p>{payDayValue}</p>
                                </li>
                                <li>
                                    <p>{currentPeriod != null ? 'Work Period' : 'Work Month'}</p>
                                    <p>{workPeriodValue}</p>
                                </li>
                                <li>
                                    <p>Work Days</p>
                                    <p>{numberOfWorkedDays}</p>
                                </li>
                                <li>
                                    <p>Work Month Base Pay</p>
                                    <p>{formatCurrency(doctorPayVariables.monthlyBasePay)}</p>
                                </li>
                                <li>
                                    <p>Work Month Billable Threshold</p>
                                    <p>{"**"}</p>
                                </li>
                                <li>
                                    <p>Billable</p>
                                    <p>{"**"}</p>
                                </li>
                                <li>
                                    <p>Total Month Earnings</p>
                                    <p>{formatCurrency(earnings)}</p>
                                </li>
                                <li>
                                    <p>Annualized Earnings</p>
                                    <p>{formatCurrency(annualizedPay)}</p>
                                </li>
                                <li>
                                    <p>Avg Daily Earnings</p>
                                    <p>{formatCurrency(dailyRatePay)}</p>
                                </li>
                                <li>
                                    <p>Pt Visits</p>
                                    <p>{patientVisits}</p>
                                </li>
                                <li>
                                    <p>Pt Visits/ Day </p>
                                    <p>{patientVisitsPerDay}</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Contract Details in first column ONLY when currentPeriod is null */}
                    {currentPeriod == null && (
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Contract Details</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Contract Type</p>
                                        <p>{contractType}</p>
                                    </li>
                                    <li>
                                        <p>Monthly Base Work Days </p>
                                        <p>{doctorPayVariables.monthlyBaseWorkDays}</p>
                                    </li>
                                    <li>
                                        <p>Day Rate</p>
                                        <p>{formatCurrency(doctorPayVariables.dailyRatePay)}</p>
                                    </li>
                                    <li>
                                        <p>Billable Care Threshold</p>
                                        <p>{"**"}</p>
                                    </li>
                                    <li>
                                        <p>Percentage of Billable Care </p>
                                        <p>{percentageOfBillable.toFixed(0)}</p>
                                    </li>
                                    <li>
                                        <p>Gross to Billable Adjustment Percentage</p>
                                        <p>{100 - prodAdjWo}</p>
                                    </li>
                                    <li>
                                        <p>Work Status</p>
                                        <p>{dentistWorkTimeType}</p>
                                    </li>
                                    {adjWoProcDateStart && (
                                        <li>
                                            <p>Adj/WO Proc Date From</p>
                                            <p style={{ color: '#e67e22', fontWeight: 'bold' }}>{adjWoProcDateStart}</p>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    )}
                </div>

                {/* Second Column */}
                <div className="col-12 col-md-6 col-lg-4">
                    {/* Contract Details in second column ONLY when currentPeriod is not null */}
                    {currentPeriod != null && (
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Contract Details</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Contract Type</p>
                                        <p>{contractType}</p>
                                    </li>
                                    <li>
                                        <p>Monthly Base Work Days </p>
                                        <p>{doctorPayVariables.monthlyBaseWorkDays}</p>
                                    </li>
                                    <li>
                                        <p>Day Rate</p>
                                        <p>{formatCurrency(doctorPayVariables.dailyRatePay)}</p>
                                    </li>
                                    <li>
                                        <p>Billable Care Threshold</p>
                                        <p>{"**"}</p>
                                    </li>
                                    <li>
                                        <p>Percentage of Billable Care </p>
                                        <p>{percentageOfBillable.toFixed(0)}</p>
                                    </li>
                                    <li>
                                        <p>Gross to Billable Adjustment Percentage</p>
                                        <p>{100 - prodAdjWo}</p>
                                    </li>
                                    <li>
                                        <p>Work Status</p>
                                        <p>{dentistWorkTimeType}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    )}

                    {/* Friday Gross Earnings in second column ONLY when currentPeriod is null */}
                    {currentPeriod == null && (
                        <div className="ui card reports-card">
                            <div className="content">
                                {payChecks && Object.entries(payChecks).map(([date, dateChecks], i) => (
                                    <div key={i}>
                                        <div className="d-flex justify-content-between flex-wrap">
                                            <h5 className="mr10">{i + 1}{(1 + i) === 1 ? 'st' : 'nd'} Friday Gross
                                                Earnings Pre-Tax</h5>
                                            <strong className="secondaryColor text-right">{date}</strong>
                                        </div>
                                        <table className="table table-striped table-hover table-sm mt-0 mb-0">
                                            <thead>
                                                <tr>
                                                    <th>OFFICE</th>
                                                    <th className="text-right">EARNINGS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dateChecks.officeChecks.map((office) => (
                                                    <tr key={i}>
                                                        <td>{office.practice}</td>
                                                        <td className="text-right">{formatCurrency(office.check)}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td><strong>Total</strong></td>
                                                    <td className="text-right">
                                                        <strong>{formatCurrency(dateChecks.total)}</strong>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {
                        providerData.teamContribution && <Card
                            meta={<b>Team Contribution</b>}
                            description={<b className={providerData.teamContribution > 0 ? 'text-green' : 'text-red'}><br />{formatCurrency(providerData.teamContribution)}</b>}
                        />
                    }

                    {/* Tier Bonus Card (always shows if applicable) */}
                    {doctorPayVariables.tierContract && (
                        <div className="ui card reports-card" style={{ backgroundColor: '#E6EEF7' }}>
                            <div className="content">
                                <h5 style={{
                                    fontSize: '15px',
                                    textAlign: 'center',
                                    marginBottom: '10px',
                                    fontWeight: 'bold'
                                }}>Tier Bonus</h5>
                                <div style={{ padding: '0 0px' }}>
                                    {tierBonusPayRecords.map((practiceValues, pVKey) => (
                                        <div key={`practice-${pVKey}`}>
                                            {practiceValues.map((record, index) => (
                                                <div key={`tier-${pVKey}-${index}`} style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: index !== practiceValues.length - 1 ? '8px' : '0',
                                                    fontSize: '12px'
                                                }}>
                                                    <span>{practiceValues[0].practiceName} </span>
                                                    <span
                                                        style={{ fontWeight: 'bold' }}>{`${formatCurrency(record.amountFrom)}-${formatCurrency(record.amountTo)} (${record.percentValue}%)`}</span>
                                                    <span
                                                        style={{ fontWeight: 'bold' }}>{(record.tierType === 1 && record.flagged) || (record.tierType !== 1) ? formatCurrency(record.bonusValue) : formatCurrency(0)}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ADP Access Card (always shows) */}
                    <div className="ui card reports-card">
                        <div className="content">
                            <h5>Accessing Your Pay Stub</h5>
                            <ul className="data-list">
                                <li>
                                    <p>Link to ADP</p>
                                    <p><a href={adpLink} target={'_blank'}><Icon name='external alternate'
                                        className="primaryColor" /></a></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Third Column (always shows) */}

            </div>

            {/* Tier Bonus Table (if applicable) */}
            {isProviderOnTierBonus && (
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-12">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>{'Tie Bonus'}</h5>
                                {tierBonusPayRecords.map((practiceValues, pVKey) => {
                                    const practiceTierRecordRows = practiceValues.map((practiceRecord, pRkey) => {
                                        return (
                                            <tr key={pRkey}>
                                                {pRkey === 0 &&
                                                    <td rowSpan={practiceValues.length}>{practiceRecord.practiceName}</td>}
                                                <td>
                                                    {`${formatCurrency(practiceRecord.amountFrom)} - ${formatCurrency(practiceRecord.amountTo)} `}
                                                </td>
                                                {tierType !== 1 && <td>
                                                    {`${formatCurrency(practiceRecord.bracketValue)}`}
                                                </td>}
                                                <td>{(practiceRecord.percentValue)}%</td>
                                                <td>{(tierType === 1 && practiceRecord.flagged) || (tierType !== 1) ? formatCurrency(practiceRecord.bonusValue) : formatCurrency(0)}</td>
                                            </tr>
                                        )
                                    });

                                    const practiceTierRecordRowsTotal = practiceValues.reduce((acc, practiceRecord) => {
                                        const total = (practiceRecord.tierType === 1 && practiceRecord.flagged) || (practiceRecord.tierType !== 1) ? acc + parseFloat(practiceRecord.bonusValue) : acc + parseFloat(0);
                                        return total;
                                    }, 0)

                                    return <div>
                                        <table className="table table-hover table-sm mt-0 mb-0">
                                            <thead>
                                                <tr>
                                                    <th> Practice</th>
                                                    <th> Range</th>
                                                    {tierType !== 1 && <th> Range Value</th>}
                                                    <th> Percent</th>
                                                    <th> Bonus</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {practiceTierRecordRows}
                                                <tr>
                                                    <td colSpan={tierType !== 1 ? 3 : 2}>Total</td>
                                                    <td>Total</td>
                                                    <td>{formatCurrency(practiceTierRecordRowsTotal)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Financial Notes Table */}
            {showFinancialNotesTable(financialNoteList, financialNotes)}
            {showTedCollectionsTable(payDetailsList)}

            {/* Pay Details Table */}
            <div className="table-responsive">
                <h5>Pay Details</h5>
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>
                                <div>SERVICE DATE</div>
                            </th>
                            <th>
                                <div>PRACTICE</div>
                            </th>
                            <th>
                                <div>GROSS CARE</div>
                            </th>
                            <th>
                                <div>ADJUSTMENT</div>
                            </th>
                            <th>
                                <div>WRITE OFF</div>
                            </th>
                            <th>
                                <div>BILLABLE CARE</div>
                            </th>
                            {Object.keys(hygData).length > 0 && <th>
                                <div>HYN BCARE</div>
                            </th>}
                            <th>
                                <div>FINANCIAL NOTES</div>
                            </th>
                            <th>
                                <div>EARNINGS</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {showPayDetailsTableRows(payDetailsList)}
                        {showTableTotals(payDetailsList)}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default GreaterOf;
